import React from 'react';
import { SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_2_XL } from '@oneaudi/unified-web-common';
import { Headline, Layout, TextButton, TextList, TextListItem, } from '@oneaudi/unified-web-components';
import { useI18nBulk } from '@oneaudi/i18n-context';
export const MyAudiWishlistLoginLayer = ({ authService, vehicle }) => {
    const translations = useI18nBulk({
        headline: { id: 'vtp-myaudi-wishlist.login-layer.headline' },
        copy1: { id: 'vtp-myaudi-wishlist.login-layer.copy.1' },
        copy2: { id: 'vtp-myaudi-wishlist.login-layer.copy.2' },
        copy3: { id: 'vtp-myaudi-wishlist.login-layer.copy.3' },
        loginButton: { id: 'vtp-myaudi-wishlist.login-layer.login-button' },
    });
    return (React.createElement(Layout, { direction: "column", align: "flex-start" },
        React.createElement(Headline, { tag: "h3", variant: { order: '3', type: 'headline', weight: 'normal' }, margin: [0, 0, SYS_SPACE_FIXED_300, 0] }, translations.headline),
        React.createElement(TextList, { variant: "bullet", size: "md" },
            React.createElement(TextListItem, null, translations.copy1),
            React.createElement(TextListItem, null, translations.copy2),
            React.createElement(TextListItem, null, translations.copy3)),
        React.createElement(TextButton, { variant: "primary", margin: [SYS_SPACE_RELATIVE_2_XL, 0, 0, 0], onClick: () => {
                localStorage.setItem(MYAUDI_WISHLIST_LOCAL_STORAGE_KEY, vehicle.id);
                authService.login(undefined, window.location.pathname + window.location.search);
            } }, translations.loginButton)));
};
export const MYAUDI_WISHLIST_LOCAL_STORAGE_KEY = 'myaudi_vehicle_id_to_wishlist';
